import { FileText } from "lucide-react";
import { useEffect, useState } from "react";
import "./recentUpdates.css";

import { useAuth } from "../../../context/AuthContext";
import {
  getRecentNotifications,
  timeAgo,
} from "../../../services/dashboardService";

export default function RecentUpdates() {
  const { globalUser } = useAuth();
  const isClient = localStorage.getItem("userType") === "client";

  const [updates, setUpdates] = useState([]);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (!globalUser?.uid) return;

    const loadUpdates = async () => {
      const data = await getRecentNotifications(globalUser.uid, isClient);
      setUpdates(data);
    };

    loadUpdates();
  }, [globalUser, isClient]);

  // Show 2 by default (was 3) so the panel ends a little higher and the floating
  // support button has clean room in the bottom-right corner.
  const visibleUpdates = showAll ? updates : updates.slice(0, 2);

  return (
    <div className="dashboard-panel recent-updates">

      <div className="panel-header">

        <div className="panel-title">
          <FileText size={18} />
          <span>Recent Updates</span>
        </div>

      </div>

      <div className="updates-list">

        {updates.length === 0 ? (
          <div className="no-hearings">
            No recent updates
          </div>
        ) : (
          visibleUpdates.map((item) => (

            <div className="update-item" key={item.id}>

              <div className="update-icon">
                <FileText size={14} />
              </div>

              <div className="update-content">
                <p>{item.title}</p>
                {item.body && (
                  <p className="update-body">{item.body}</p>
                )}
                <span>{timeAgo(item.date)}</span>
              </div>

            </div>

          ))
        )}

      </div>

      {updates.length > 2 && (
        <button
          className="panel-link updates-link"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? "Show less" : "View all updates"}
        </button>
      )}

    </div>
  );
}
